import { ServiceStatus } from '../../types';
import { statusColors, statusLabels } from '../../utils/status';

interface Props {
  status: ServiceStatus;
  size?: 'sm' | 'md';
}

export function StatusBadge({ status, size = 'md' }: Props) {
  const dotSize = size === 'sm' ? 'w-2 h-2' : 'w-2.5 h-2.5';
  const textSize = size === 'sm' ? 'text-xs' : 'text-sm';

  return (
    <span className={`inline-flex items-center gap-1.5 ${textSize}`}>
      <span className={`${dotSize} rounded-full ${statusColors[status]}`} />
      <span className="font-medium capitalize">{statusLabels[status]}</span>
    </span>
  );
}
